import { Header, HeaderActionBack, HeaderActionCustomerService } from "@/components/Header";
import { Layout } from "@/components/Layout";
import { useOutLogic } from "./useOutLogic";
import { HeaderTabs } from "./tabs";
import { Description } from "./Description";
import { dictMap, outFormItems } from "./data";
import styles from './styles.module.scss';
import { DynamicForm } from "../trade/components/DynamicForm";
import { CryptoTradingProvider } from "@/stores/cryptoTradingContext";
import { Button } from "antd-mobile";
import { useMemo } from "react";
export const Wrapper = () => {
  const logic = useOutLogic();
  const formFooter = useMemo(() => {
    return <div className={styles.footer}>
      <Button className={"common-submit-button"} onClick={() => {
        logic.onSubmit();
      }}>
        {'确定转出'}
      </Button>
    </div>;
  }, []);

  // const paymentType = useMemo(() => {
  //   console.log(logic.data.paymentType)
  //   return logic.data.paymentType ? logic.data.paymentType[0] : '';
  // }, [logic.data.paymentType])

  return <Layout scrollable backgroundImage={false} header={<Header title="保证金转出" leftActions={<HeaderActionBack />} rightActions={<HeaderActionCustomerService />} />} data-sentry-element="Layout" data-sentry-component="Wrapper" data-sentry-source-file="out.tsx">
      <HeaderTabs actived={'out'} data-sentry-element="HeaderTabs" data-sentry-source-file="out.tsx" />
      <div className={styles.main}>
      
        <div className={styles.form}>
          <DynamicForm data={logic.data} dictMap={logic.dictMap} items={outFormItems} onRef={logic.onFormRef} onValuesChange={logic.onValuesChange} data-sentry-element="DynamicForm" data-sentry-source-file="out.tsx" />
        </div>
        <Description data-sentry-element="Description" data-sentry-source-file="out.tsx" />
      </div>
      {formFooter}
    </Layout>;
};
export const PageCryptoTransferOut = () => {
  return <CryptoTradingProvider data-sentry-element="CryptoTradingProvider" data-sentry-component="PageCryptoTransferOut" data-sentry-source-file="out.tsx">
    <Wrapper data-sentry-element="Wrapper" data-sentry-source-file="out.tsx" />
  </CryptoTradingProvider>;
};